import { useMutation } from "react-query";
import servicesUtils from "../../../../utils/servicesUtils";

const useAddMessages = (workspaceId, conversationId) => {
  let url = `/llm_orchestrator/workspaces/${workspaceId}/conversations/${conversationId}/messages/`;
  return useMutation((params) => servicesUtils.postService(url, params));
};

export default useAddMessages;
